import { render, staticRenderFns } from "./SettingGoldBetweenHeroLevelsAndSkills.vue?vue&type=template&id=3960ba84&scoped=true&"
import script from "./SettingGoldBetweenHeroLevelsAndSkills.vue?vue&type=script&lang=js&"
export * from "./SettingGoldBetweenHeroLevelsAndSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960ba84",
  null
  
)

export default component.exports